var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 73,
    viewBox: "0 0 168 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_62_1172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.0001 71.7313C130.009 71.7313 167.306 55.9216 167.306 36.4193C167.306 16.9171 130.009 1.10742 84.0001 1.10742C37.9916 1.10742 0.694336 16.9171 0.694336 36.4193C0.694336 55.9216 37.9916 71.7313 84.0001 71.7313Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9999 71.7313C103.676 71.7313 119.627 55.9216 119.627 36.4193C119.627 16.9171 103.676 1.10742 83.9999 1.10742C64.3236 1.10742 48.3728 16.9171 48.3728 36.4193C48.3728 55.9216 64.3236 71.7313 83.9999 71.7313Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0001 49.4252C91.2464 49.4252 97.1207 43.6028 97.1207 36.4206C97.1207 29.2384 91.2464 23.416 84.0001 23.416C76.7537 23.416 70.8794 29.2384 70.8794 36.4206C70.8794 43.6028 76.7537 49.4252 84.0001 49.4252Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_1172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 168,
    height: 72,
    fill: "white",
    transform: "translate(0 0.419922)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.3427aac9a325677b2f6e34ac9b4e3f04.svg";
export { ForwardRef as ReactComponent };